import { render } from "./Cropper.vue?vue&type=template&id=4fa6c8be&ts=true&lang=pug"
import script from "./Cropper.vue?vue&type=script&lang=ts&setup=true"
export * from "./Cropper.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__